import { IconButton } from "@mui/material";
import React from "react";
import EyeIcon from "./icon/EyeIcon";

export default function ViewBtn({ handleView, ...props }) {
  return (
    <IconButton
      disabled={props?.disabled}
      sx={{ width: "32px", height: "32px", background: "var(--grey) !important", color: props.disabled ? "#b0b0b0" : "#000" }}
      onClick={handleView}
    >
      <EyeIcon sx={{ fontSize: "16px" }} />
    </IconButton>
  );
}
